import gsap from 'gsap';
import React, { useCallback, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Icon } from '../';
const Wrapper = styled.div ``;
export const IconChecklist = ({ className, onDone, running }) => {
    const wrapperRef = useRef(null);
    const triggerDone = useCallback(() => {
        if (onDone) {
            onDone();
        }
    }, [onDone]);
    useEffect(() => {
        if (running) {
            const wrapper = wrapperRef.current;
            const firstRow = wrapper?.querySelector('g g:nth-child(1)');
            const firstRowPaths = firstRow?.querySelectorAll('path');
            const secondRow = wrapper?.querySelector('g g:nth-child(2)');
            const thirdRow = wrapper?.querySelector('g g:nth-child(3)');
            if (!firstRow || !firstRowPaths || !secondRow || !thirdRow) {
                return;
            }
            gsap.to([secondRow, thirdRow], {
                y: 4.17,
                duration: 0.25,
                onComplete: () => {
                    gsap.to(firstRowPaths, {
                        opacity: 1,
                        stagger: -0.15,
                        duration: 0.2,
                        ease: 'linear',
                        onComplete: () => {
                            triggerDone();
                            gsap.to([firstRow, secondRow, thirdRow, firstRowPaths], {
                                clearProps: true,
                                duration: 0,
                            });
                        },
                    });
                },
            });
            gsap.to(thirdRow, {
                opacity: 0,
                duration: 0.15,
            });
        }
    }, [running]);
    return (React.createElement(Wrapper, { className: className, ref: wrapperRef },
        React.createElement(Icon.Checklist, null)));
};
//# sourceMappingURL=Checklist.js.map